import axios from 'axios';

export default {

    getCountries () {
        return axios.get('/api/countries/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    getCities (countryId) {
        return axios.get('/api/countries/cities', { params: { countryId: countryId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },
}

